"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = exports.SwitchElement = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const react_switch_1 = __importDefault(require("react-switch"));
const utils_2 = require("./utils");
const aria_1 = require("./utils/aria");
const StyledWrap = app_1.styled.label `
  display: flex;
  align-items: center;
`;
const StyledLabelWrap = app_1.styled.span `
  ${(theme) => theme.inputs.label}
  position: initial;
  padding: 0;
  margin-left: ${(theme) => theme.spacing.extraSmall};
`;
function SwitchElement(_a) {
    var { value, label, onChange, onBlur, className, success, hasError, suffix, prefix, optional } = _a, props = __rest(_a, ["value", "label", "onChange", "onBlur", "className", "success", "hasError", "suffix", "prefix", "optional"]);
    const remToPx = (0, app_1.useRemToPx)();
    const id = (0, app_1.useCuid)();
    const [focus, setFocus] = (0, react_1.useState)(false);
    const focusVisible = (0, utils_1.cls)({ 'focus-visible': focus });
    const theme = (0, app_1.useTheme)();
    const disabled = Boolean(props.disabled);
    const normalizedProps = (0, react_1.useMemo)(() => (0, utils_1.exclude)(Object.assign(Object.assign({}, props), { className: (0, utils_1.cls)(className, focusVisible) }), undefined), [className, focusVisible, props]);
    return ((0, jsx_runtime_1.jsxs)(StyledWrap, Object.assign({ htmlFor: id }, { children: [(0, jsx_runtime_1.jsx)(react_switch_1.default, Object.assign({}, normalizedProps, { width: remToPx(2.625), height: remToPx(1.5), handleDiameter: remToPx(1), onChange: (checked) => {
                    onChange === null || onChange === void 0 ? void 0 : onChange(checked);
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(checked);
                }, onFocusCapture: () => setFocus(true), onBlurCapture: () => setFocus(false), checked: value, checkedIcon: false, uncheckedIcon: false, offColor: String(theme.colors.primary.brightness(0.925)), onColor: String(theme.accent), boxShadow: "box-shadow: 0px 2px 4px 0px #000000", activeBoxShadow: "none" })), label && ((0, jsx_runtime_1.jsx)(StyledLabelWrap, Object.assign({}, (0, aria_1.aria)({ invalid: hasError, success, disabled }), { onClick: () => {
                    onChange === null || onChange === void 0 ? void 0 : onChange(!value);
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(!value);
                } }, { children: label })))] })));
}
exports.SwitchElement = SwitchElement;
function Switch(_a) {
    var { defaultValue } = _a, props = __rest(_a, ["defaultValue"]);
    return ((0, jsx_runtime_1.jsx)(utils_2.InputController, Object.assign({}, props, { render: SwitchElement, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : false, optional: true })));
}
exports.Switch = Switch;
